import { FC } from "react";
import { Fab } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";

const MuteButton: FC<{ muted: boolean; onClick: () => void }> = ({
  muted,
  onClick,
}) => {
  return (
    <Fab onClick={onClick} color="info" size="small">
      {muted ? <MicOffIcon /> : <MicIcon />}
    </Fab>
  );
};

export default MuteButton;
